module.exports = __webpack_public_path__ + "static/media/alien.2bea8e79.m4a";